import type {CommandSearchScope} from './types';

/** Returns the id of the innermost scope frame matching `type`, if present. */
export const getScopeFrameId = (scope: CommandSearchScope, type: string): string | undefined => {
    for (let index = scope.stack.length - 1; index >= 0; index -= 1) {
        if (scope.stack[index].type === type) {
            return scope.stack[index].id;
        }
    }
    return undefined;
};

/** Builds the conventional route param name for a scope type (`customer` → `customerId`). */
export const scopeTypeToParamName = (scopeType: string): string =>
    scopeType.endsWith('Id') ? scopeType : `${scopeType}Id`;

/**
 * Resolves a scoped route template using the active scope stack.
 *
 * @example
 * resolveScopedRoute('/:customerId/invoices/list', scope, 'customer')
 * // → '/10/invoices/list' when scope contains customer:10
 */
export const resolveScopedRoute = (
    template: string,
    scope: CommandSearchScope,
    scopeType: string,
): string | undefined => {
    const id = getScopeFrameId(scope, scopeType);
    if (!id) {
        return undefined;
    }

    const paramName = scopeTypeToParamName(scopeType);
    return template
        .replace(new RegExp(`:${paramName}\\b`, 'g'), id)
        .replace(new RegExp(`:${scopeType}\\b`, 'g'), id)
        .replace(/:id\b/g, id);
};
